import { forwardRef, ForwardRefRenderFunction } from "react";
import { BaseIconProps } from "../../types/styles";

const QuestionIconRender: ForwardRefRenderFunction<
    SVGSVGElement,
    BaseIconProps
> = ({ id, size = 24, ...rest }, ref) => {
    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-question"}
            ref={ref}
            width={size}
            height={size}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            <path
                d="M12,22c5.52,0,10-4.48,10-10S17.52,2,12,2,2,6.48,2,12s4.48,10,10,10Z"
                fill="none"
                stroke="#d8d8d8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12,17h.01"
                fill="none"
                stroke="#d8d8d8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.09,9c.24-.67.7-1.23,1.31-1.59.61-.36,1.33-.49,2.03-.37.7.12,1.33.48,1.79,1.02.46.54.71,1.23.7,1.94,0,2-3,3-3,3"
                fill="none"
                stroke="#d8d8d8"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const QuestionIcon = forwardRef<SVGSVGElement, BaseIconProps>(
    QuestionIconRender
);

export default QuestionIcon;
